import React, { Component } from 'react';
import InstagramService from '../../../services/instagram';

import './candiates-auto-names.css';

class InstagramCandidatesAutoNames extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isError: false,
      isLoading: true,
    };

    this.getCandidates(props);
  }

  getCandidates(props) {
    InstagramService.getCandidatesAutoNames(props.location.search)    
      .then((candidates) => {
        this.setState({ 
          candidates: candidates.map(c => ({
            ...c,
            approved: true
          })),
          isLoading: false
        });
      })
      .catch((err) => {
        const errorMessage = err && err.response && err.response.data;
        this.setState({ isError: true, errorMessage: errorMessage });
      });
  }

  getOnChange = (name) => {
    return (event) => {
      this.setState((prevState) => {
        return {
          candidates: prevState.candidates.map(candidate => {
            const additionals = {};

            if (candidate.name === name) {
              additionals.approved = !candidate.approved;
            }

            return {
              ...candidate,
              ...additionals
            };
          })
        }
      })
    }
  }

  onSave = () => {
    this.setState({
      isLoading: true,
    });
    
    InstagramService.saveCandidatesAutoNames(this.state.candidates.map(({ freq, ...c}) => c))    
      .then(() => {
        window.location.reload();
      })
      .catch((err) => {
        const errorMessage = err && err.response && err.response.data;
        this.setState({ isError: true, errorMessage: errorMessage });
      });
  }

  render() {
    let body = 'Processing...';
    if (this.state && this.state.candidates && !this.state.isLoading) {
      body = (
        <div>  
          <input type='button' value='Save' onClick={this.onSave}/>

          <section>
            {
              this.state.candidates.map((candidate, i) => 
                <div key={candidate.name} 
                  className={(!candidate.approved && 'hide') || ''}
                  onClick={this.getOnChange(candidate.name)}
                  >
                  { candidate.name }
                  {/* <div><label>{i + 1} out of {this.state.candidates.length}</label></div> */}
                <hr/>
              </div>
              )
            }
          </section>

          <input type='button' value='Save' onClick={this.onSave}/>
        </div>
      );
    }

    if (this.state.isError) {
      body = 'Error';
      body += this.state.errorMessage ? `: ${this.state.errorMessage}` : '';
    }

    return (
      <section className='regular-page instagram-candidates'>
        {body}
      </section>
    );
  }
}

export default InstagramCandidatesAutoNames;
